import React from 'react';
import { Link } from 'react-router-dom';
import { Package, ArrowRight } from 'lucide-react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
const PACKAGES = ['Game Uniforms', 'Warm-Ups & Shooter Shirts', 'Hoodies & Team Apparel', 'Bags & Accessories', 'Fan Gear', 'Reorders & Matching Gear'];
export function TeamPackages() {
  return <section className="py-20 bg-[#111827] text-white" data-id="element-250">
      <Container data-id="element-251">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-252">
          <div className="lg:w-1/2" data-id="element-253">
            <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-6" data-id="element-254">
              Team Packages Built Around Your Sport
            </h2>
            <div className="w-24 h-1.5 bg-pts-red mb-6" data-id="element-255"></div>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-256">
              Whether you need full uniforms, shooter shirts, warm-ups, hoodies,
              bags, or fan gear, PTS can help build packages for your team,
              league, club, school, or organization.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-257">
              {PACKAGES.map((pkg, index) => <div key={index} className="flex items-center bg-gray-800/50 p-4 rounded border border-gray-700" data-id="element-258">
                  <Package className="h-5 w-5 text-pts-red mr-3 flex-shrink-0" data-id="element-259" />
                  <span className="font-medium" data-id="element-260">{pkg}</span>
                </div>)}
            </div>

            <Link to="/get-started" className="inline-flex items-center bg-pts-red hover:bg-pts-red-dark text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors" data-id="element-261">
              Build My Team Package
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-262" />
            </Link>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-263">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="relative rounded-xl overflow-hidden shadow-2xl border border-gray-800" data-id="element-264">
              <img src="https://cdn.magicpatterns.com/uploads/uXtc1F1bThsX3mEVuxfCvT/team-packages.jpg" alt="Team in coordinated custom uniforms and gear" className="w-full h-auto object-cover aspect-[4/3]" data-id="element-265" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#111827]/60 via-transparent to-transparent" data-id="element-266"></div>
            </motion.div>
          </div>
        </div>
      </Container>
    </section>;
}